import { authHeader } from '@/_helpers'
import { store } from '@/_store'

export const usersService = {
  login,
  logout,
  create,
  addNewUser,
  deleteUser,
  deleteUsers,
  verificationCode,
  verificationCodeLoggedIn,
  getAll,
  getUserSettings,
  getNotifications,
  createSchedulePage,
  getScheduleData,
  getNotificationsIssues,
  setUserSettings,
  changePassword,
  requestNewPassword,
  sendImprovement,
  getList,
  getGroupList,
  getUserGroupList,
  getAllGroups,
  getAllGroupsByUser,
  deleteMember,
  getUserById,
  saveCalendly,
  getCalendly,
  hasPaymentDefault,
  getAuthenticationUrl,
  verificationAuthenticationCode,
  getEmailSettings,
  deactivateEmailSettings,
  setParameters,
  refreshToken,
  downgrade,
  resendVerificationCode,
  verificationCodeAdmin,
  unBlock,
  getAllByFilter,
  addSalesRep,
  getCheckMail,
  getSales,
  addSalesRepChild,
  getClientNylas,
  getNylasIntegrationUrl,
  setNylasIntegration,
  getClientTotalContacts,
  editEmail,
  changeRoleUserTeam,
  registerSawVideoTraining,
  getSalesChild,
  getSalesTeam,
  getSalesByClient,
  updateSalesRepParent,
  setSwitches,
  getUserOliverSales,
  assignUserOliverSaleToClient,
  getBdrs,
  getSaleStats,
  getOliverSalesDashboard,
  getOliverSalesDashboardMonhts,
  getOliverSalesDashboardDetail,
  getStatsOperators,
  getOliverSalesActions,
  getOliveSaleAllRevenue,
  getOliverSalesTeam,
  getOliverSalesAchievements,
  getSalesBurnedDomains,
  getBdrMonthlyMetrics,
  getStatsMetrics,
  getUserBookerByClient,
  getBookerDaily,
  getBookerStatsDailyTotals,
  getBookerStatuses,
  getNonWorkingDays,
  updateNonWorkingDays,
  getBackupCandidates,
  getBackup,
  updateBackup,
  getClientsOfBooker,
  getTargetActiveByClients,
  getUserBookerByTarget,
  getUserOliverExecutives,
  getOrdersBooker,
  saveUserClientDetail,
  getUsersByRole,
  getBookerRecruiters
}

const apiUrl = process.env.VUE_APP_ROOT_API

// fetch() rechaza sin decir que llamada fallo. Se le pega la URL y el metodo al
// error para que el handler de alertas pueda dejarlo en consola: sin esto un
// fallo de red no deja ningun rastro y soporte diagnostica a ciegas.
function tagRequest(error, url, method) {
  try {
    error.url = url
    error.method = method
  } catch (e) {
    // si el error es inmutable se deja como estaba
  }
  throw error
}

function login(username, password) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password }),
    credentials: 'include', // include, same-origin, omit
  }

  return fetch(`${apiUrl}/users/login`, requestOptions)
    .catch((error) => tagRequest(error, `${apiUrl}/users/login`, requestOptions.method))
    .then(handleResponse)

    .then((user) => {

      if (user.role_id != "1") {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          'event': 'page_view',
          'customer_id': user.id,
          'user_Name': user.name,
          'user_LastName': user.lastname,
          'user_Mail': user.email,
          'user_Phone': user.phone,
          'user_Country': user.lang_code,
          'user_City': user.client_city,
          'user_postalcode': user.client_postal_code,
          'langue': user.lang_code
        });
      }
      // login successful if there's a jwt token in the response
      /*if (user.token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                //localStorage.setItem('user', JSON.stringify(user));
                this.hasPaymentDefault().then(response => {
                    if(response.trialPeriodEnded.result == 1 &&
                        response.hasDefaultPaymentMethod.length == 0){
                        localStorage.setItem('trialPeriodEnded', true);
                    } else{
                        localStorage.setItem('trialPeriodEnded', false);
                    }
                    localStorage.setItem('subscriptionActive', response.subscriptionActive);
                })

                // Initialize variables for user filter of priority product and category
                localStorage.setItem('priorityCategoryFilter', JSON.stringify({}));
                localStorage.setItem('priorityProductFilter', JSON.stringify({}));
            }*/
      return user
    })
}

function refreshToken() {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include', // include, same-origin, omit
  }

  return fetch(`${apiUrl}/users/refresh-token`, requestOptions)
    .catch((error) => tagRequest(error, `${apiUrl}/users/refresh-token`, requestOptions.method))
    .then(handleResponse)
}

function createSchedulePage(campaign_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ campaign_id }),
  }
  return fetch(`${apiUrl}/users/add-scheduler-page`, requestOptions).then(
    handleResponse,
  )
}

function editEmail(data) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify(data),
  }
  return fetch(`${apiUrl}/users/sale_edit_user`, requestOptions).then(
    handleResponse,
  )
}

function getScheduleData(calendar_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ calendar_id }),
  }
  return fetch(`${apiUrl}/users/get-scheduler-data`, requestOptions).then(
    handleResponse,
  )
}

function verificationCode(code, username, password) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ code, username, password }),
  }
  return fetch(`${apiUrl}/users/verificationcode`, requestOptions).then(
    handleResponse,
  )
}

function verificationCodeLoggedIn(code) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ code }),
  }
  return fetch(`${apiUrl}/users/verificationcodeloggedin`, requestOptions).then(
    handleResponse,
  )
}

function verificationCodeAdmin(userid) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ userid }),
  }
  return fetch(`${apiUrl}/users/verificationcodeadmin`, requestOptions).then(
    handleResponse,
  )
}

function unBlock(userid) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ userid }),
  }
  return fetch(`${apiUrl}/users/unblock`, requestOptions).then(handleResponse)
}

function create(data) {
  const user = store.state.authentication.user;

  if (user && user.token) {
    if (user.role_id == 1 || user.role_id == 5) {
      const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ user: data }),
      }

      return fetch(`${apiUrl}/users/create-from-admin`, requestOptions)
        .then(handleResponse)
        .then((res) => {

          if(res.id){
            return res
          }else{
            return user
          }

        })
    }

  } else {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ user: data }),
    }

    window.dataLayer = window.dataLayer || []
    dataLayer.push({
      event: 'formSubmission',
      formType: 'create_account',
    })

    return fetch(`${apiUrl}/users/create`, requestOptions)
      .then(handleResponse)
      .then((user) => {
        // login successful if there's a jwt token in the response
        if (user.token) {
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          localStorage.setItem('user', JSON.stringify(user))
          // Initialize variables for user filter of priority product and category
          localStorage.setItem('priorityCategoryFilter', JSON.stringify({}))
          localStorage.setItem('priorityProductFilter', JSON.stringify({}))
        }
        return user
      })
  }


}

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem('user')
  localStorage.removeItem('xkhx$$')
  // Remove user filter of priority product and category
  localStorage.removeItem('priorityProductFilter')
  localStorage.removeItem('priorityCategoryFilter')
  localStorage.clear
  sessionStorage.clear
}

function getAll() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }

  return fetch(`${apiUrl}/users/`, requestOptions).then(handleResponse)
}

function getSalesChild() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/users/saleschild`, requestOptions).then(handleResponse)

}

function getBdrs(statuses = 0, filterBoookerWithoutOrder = 0, target_id = 0, additional_data = 0, is_booker_manager = 0) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/users/get_users_bdr?statuses=${statuses}&booker_without_order=${filterBoookerWithoutOrder}&target_id=${target_id}&additional_data=${additional_data}&is_booker_manager=${is_booker_manager}&cache=true&time=360&allusers=true`, requestOptions).then(handleResponse)
}

function getBookerStatsDailyTotals() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/users/get-booker-stats-daily-totals?cache=true&time=1800`, requestOptions).then(handleResponse)
}



function getSalesTeam(type) {

  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ type }),
  }

  return fetch(`${apiUrl}/users/team`, requestOptions).then(handleResponse)

}

function getSalesBurnedDomains(active, count = 0) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/users/get-sales-burned-domains?count=${count}&active=${active}`, requestOptions).then(
    handleResponse,
  )
}

function addNewUser(data) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ user: data }),
  }

  return fetch(`${apiUrl}/users/`, requestOptions).then(handleResponse)
}

function deleteUser(id) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/users/${id}`, requestOptions).then(handleResponse)
}

function deleteUsers(ids) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ ids }),
  }
  return fetch(`${apiUrl}/users/delete`, requestOptions).then(handleResponse)
}

function getBookerStatuses() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/users/get-booker-statuses`, requestOptions).then(
    handleResponse,
  )
}

function getUserById(id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/users/user/${id}`, requestOptions).then(
    handleResponse,
  )
}

function getSaleStats(type, month = 0) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/targets/get-oliver-sales-stats?option=${type}&month=${month}`, requestOptions).then(
    handleResponse,
  )
}


function getOliverSalesActions(oliver_sale_id, currentPage, cantPerPage, getTotal) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/users/get-oliversale-actions?oliver_sale_id=${oliver_sale_id}&currentPage=${currentPage}&cantPerPage=${cantPerPage}&getTotal=${getTotal}`, requestOptions).then(
    handleResponse,
  )
}

function getStatsOperators() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/users/get-stats-operators`, requestOptions).then(
    handleResponse,
  )
}

function getClientsOfBooker(user_id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/users/get-clients-of-booker?user_id=${user_id}`, requestOptions).then(
    handleResponse,
  )
}

function getUserBookerByClient(client_id) {
  
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/users/get-bookers-by-client?client_id=${client_id}&cache=true&time=10800&allusers=true`, requestOptions).then(
    handleResponse,
  )
}



function getOrdersBooker(user_id, params) {

  const queryString = new URLSearchParams({
    ...params
  }).toString();
  
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/bookers/booker-orders/${user_id}?${queryString}`, requestOptions).then(
    handleResponse,
  )
}

function getUserBookerByTarget(target_id) {
  
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/users/get-bookers-by-target?target_id=${target_id}&cache=true&time=10800&allusers=true`, requestOptions).then(
    handleResponse,
  )
}

function getTargetActiveByClients(client_ids){
    const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ client_ids })
  }
  return fetch(`${apiUrl}/users/get-targets-active-by-clients`, requestOptions).then(handleResponse);
}

function getStatsMetrics(item, task_type_id = 0, start_date = 0, end_date = 0, status = 0) {
  
  let uri = `/users/get-stats-metrics?option=${item}&task_type_id=${task_type_id}&status=${status}` 

  if(start_date != 0 && end_date != 0){
    uri = `/users/get-stats-metrics?option=${item}&task_type_id=${task_type_id}&start_date=${start_date}&end_date=${end_date}&status=${status}`; 
  }   
  
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}${uri}`, requestOptions).then(
    handleResponse,
  )
}

function getOliverSalesDashboard(type, year_month = 0, user_type, user_id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/users/get-oliver-sales-dashboard?option=${type}&year_month=${year_month}&user_type=${user_type}&user_id=${user_id}`, requestOptions).then(
    handleResponse,
  )
}

function getBdrMonthlyMetrics(type, bdr_user_id = 0, yearMonth = 0) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/users/get-bdr-monthly-metrics?option=${type}&year_month=${yearMonth}&bdr_user_id=${bdr_user_id}`, requestOptions)
    .then( handleResponse,
  )
}

function getNonWorkingDays(yearMonth, user_id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/users/get-non-working-days/${user_id}/${yearMonth}`, requestOptions)
    .then( handleResponse,
  )
}

function updateNonWorkingDays(user_id, days_non_working) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ user_id, days_non_working }),
  }
  return fetch(`${apiUrl}/users/update-non-working-days`, requestOptions).then(handleResponse)
}

function getBackupCandidates(user_id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/users/get-backup-candidates/${user_id}`, requestOptions).then(handleResponse)
}

function getBackup(user_id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/users/get-backup/${user_id}`, requestOptions).then(handleResponse)
}

function updateBackup(user_id, backup_user_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ user_id, backup_user_id }),
  }
  return fetch(`${apiUrl}/users/update-backup`, requestOptions).then(handleResponse)
}

function getOliverSalesAchievements(oliver_sale_id = 0, month = 0) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/users/get-oliver-sales-achievements?month=${month}&oliver_sale_id=${oliver_sale_id}`, requestOptions).then(
    handleResponse,
  )
}

function getOliverSalesDashboardDetail(type, user_id = 0, month = 0, user_type = 0) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/users/get-oliver-sales-dashboard-detail?option=${type}&month=${month}&user_id=${user_id}&user_type=${user_type}`, requestOptions).then(
    handleResponse,
  )
}



function getOliverSalesTeam() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/users/get-sales-team`, requestOptions)
  .then(
    handleResponse,
  )
}


function getOliverSalesDashboardMonhts(type, oliver_sale_id = 0) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/users/get-oliver-sales-dashboard-months?option=${type}&oliver_sale_id=${oliver_sale_id}`, requestOptions).then(
    handleResponse,
  )
}

function getOliveSaleAllRevenue(oliver_sale_id = 0) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/users/get-oliver-sales-all-revenue?oliver_sale_id=${oliver_sale_id}`, requestOptions)
  .then(
    handleResponse,
  )
}



function getClientNylas() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/users/clientNylas`, requestOptions).then(
    handleResponse,
  )
}

function getList(currentPage, cantPerPage, searchFilter) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(
    `${apiUrl}/users/filtered-list?currentPage=${currentPage}&cantPerPage=${cantPerPage}&searchFilter=${searchFilter}`,
    requestOptions,
  ).then(handleResponse)
}

function getSales(id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ id }),
  }
  return fetch(`${apiUrl}/users/sales`, requestOptions).then(handleResponse)
}

function getSalesByClient(client_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ client_id }),
  }
  return fetch(`${apiUrl}/users/sales-by-client`, requestOptions).then(handleResponse)
}

function getGroupList(clientId = null) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  let url = "";
  if (clientId) {
    url = "users/mygroup?client_id=" + clientId;
  } else {
    url = "users/mygroup";
  }
  return fetch(`${apiUrl}/${url}`, requestOptions).then(handleResponse)
}

function getUserGroupList(id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ id }),
  }
  return fetch(`${apiUrl}/users/usergrouplist`, requestOptions).then(
    handleResponse,
  )
}

function deleteMember(team_user_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ team_user_id }),
  }
  return fetch(`${apiUrl}/users/deletegroupmember`, requestOptions).then(
    handleResponse,
  )
}

function getAllGroups() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/users/groups`, requestOptions).then(handleResponse)
}

function getAllGroupsByUser(user_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ user_id }),
  }
  return fetch(`${apiUrl}/users/getgroups`, requestOptions).then(handleResponse)
}

function getAllByFilter(currentPage, cantPerPage, searchFilter) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ currentPage, cantPerPage, searchFilter }),
  }
  return fetch(`${apiUrl}/users/filtered-list`, requestOptions).then(
    handleResponse,
  )
}

function assignUserOliverSaleToClient(user_id, client_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ user_id, client_id }),
  }
  return fetch(`${apiUrl}/users/register_olver_sales_to_client`, requestOptions).then(
    handleResponse,
  )
}



function getBookerDaily(all_oliver_sales = 0, completeData = 0, year_month = 0) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/users/get-bookers-daily`, requestOptions).then(
    handleResponse,
  )
}

function getUserOliverSales(all_oliver_sales = 0, completeData = 0, year_month = 0) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/users/oliver_sales?complete_data=${completeData}&year_month=${year_month}&all_oliver_sales=${all_oliver_sales}`, requestOptions).then(
    handleResponse,
  )
}

function getUserOliverExecutives(){
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/users/get-account-executives`, requestOptions).then(
    handleResponse,
  )
}

function getUsersByRole(roles) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ roles }),
  }
  return fetch(`${apiUrl}/users/get-users-by-role`, requestOptions).then(
    handleResponse,
  )
}

function getCheckMail(mail) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/users/check-email/${mail}`, requestOptions).then(
    handleResponse,
  )
}

function addSalesRep(data) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ data }),
  }
  return fetch(`${apiUrl}/users/add-sales-rep`, requestOptions).then(
    handleResponse,
  )
}

function updateSalesRepParent(sales_representative_id, new_parent_sales_representative_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ sales_representative_id, new_parent_sales_representative_id }),
  }
  return fetch(`${apiUrl}/users/update-parent-sales-rep`, requestOptions).then(
    handleResponse,
  )

}

function addSalesRepChild(sales_representative_id, client_id, howManyTeams = 1) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ sales_representative_id, client_id, howManyTeams }),
  }
  return fetch(`${apiUrl}/users/add-sales-rep-child`, requestOptions).then(
    handleResponse,
  )
}

function getUserSettings() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }

  return fetch(`${apiUrl}/users/account`, requestOptions).then(handleResponse)
}
function getNotifications() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }

  return fetch(`${apiUrl}/users/notifications`, requestOptions).then(
    handleResponse,
  )
}

function getNotificationsIssues() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }

  return fetch(`${apiUrl}/users/notifications-issues`, requestOptions).then(
    handleResponse,
  )
}

function saveCalendly(calendly) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ calendly: calendly }),
  }

  return fetch(`${apiUrl}/calendly/calendly`, requestOptions).then(
    handleResponse,
  )
}

function getCalendly(user_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ user_id: user_id }),
  }
  return fetch(`${apiUrl}/calendly/getcalendly`, requestOptions).then(
    handleResponse,
  )
}

function setUserSettings(user, client, avatar) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({
      user: user,
      client: client,
      avatar: avatar,
    }),
  }

  return fetch(`${apiUrl}/users/account`, requestOptions).then(handleResponse)
}

function changePassword(user_id, currentPassword, newPassword) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({
      user_id: user_id,
      currentPassword: currentPassword,
      newPassword: newPassword,
    }),
  }

  return fetch(`${apiUrl}/users/changePassword`, requestOptions).then(
    handleResponse,
  )
}

function sendImprovement(message) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({
      message: message,
    }),
  }

  return fetch(`${apiUrl}/users/improvement`, requestOptions).then(
    handleResponse,
  )
}

function requestNewPassword(email) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email: email }),
  }

  return fetch(`${apiUrl}/users/request-new-password`, requestOptions).then(
    handleResponse,
  )
}

function hasPaymentDefault() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }

  return fetch(`${apiUrl}/users/has-payment-default`, requestOptions).then(
    handleResponse,
  )
}

function getClientTotalContacts(clientID) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({
      client_id: clientID,
    }),
  }

  return fetch(`${apiUrl}/users/getTotalContacts`, requestOptions).then(
    handleResponse,
  )
}

function getAuthenticationUrl(email, firstname, lastname, user_id, service, provider) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({
      email_address: email,
      first_name: firstname,
      last_name: lastname,
      user_id: user_id,
      service,
      provider: provider
    }),
  }

  return fetch(`${apiUrl}/users/authentication`, requestOptions).then(
    handleResponse,
  )
}

function verificationAuthenticationCode(code, state) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({
      code: code,
      state: state,
    }),
  }
  return fetch(`${apiUrl}/users/authentication-code`, requestOptions).then(
    handleResponse,
  )
}

//Funcion para que el billing pueda cambiar el Role de sus usuarios.
function changeRoleUserTeam(userId, roleId) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({
      userId: userId,
      role_id: roleId,
    }),
  }
  return fetch(`${apiUrl}/users/change-role`, requestOptions).then(
    handleResponse,
  )
}

function getNylasIntegrationUrl(provider) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(
    `${apiUrl}/users/integration-url/${provider}`,
    requestOptions,
  ).then(handleResponse)
}

function setNylasIntegration(data) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify(data),
  }
  return fetch(`${apiUrl}/users/integration-success`, requestOptions).then(
    handleResponse,
  )
}

function getEmailSettings(user_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ user_id }),
  }

  return fetch(`${apiUrl}/users/get-email-settings`, requestOptions).then(
    handleResponse,
  )
}

function deactivateEmailSettings(user_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ user_id }),
  }

  return fetch(
    `${apiUrl}/users/email-settings/deactivate`,
    requestOptions,
  ).then(handleResponse)
}

function setParameters(categories_search_function, categories_search_level) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({
      categories_search_function,
      categories_search_level,
    }),
  }

  return fetch(`${apiUrl}/users/parameters`, requestOptions).then(
    handleResponse,
  )
}

function downgrade(data) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ data }),
  }

  return fetch(`${apiUrl}/users/downgrade`, requestOptions).then(handleResponse)
}

function registerSawVideoTraining() {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
  }

  return fetch(`${apiUrl}/users/sale-video-training`, requestOptions).then(
    handleResponse,
  )
}

function resendVerificationCode(username) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username }),
  }

  return fetch(`${apiUrl}/users/resend-verificationcode`, requestOptions).then(
    handleResponse,
  )
}

function setSwitches(switches) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({
      switches
    }),
  }
  return fetch(`${apiUrl}/users/switches`, requestOptions).then(
    handleResponse,
  )
}

function saveUserClientDetail(params){
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify(params),
  }

  return fetch(`${apiUrl}/users/update-user-basic-data`, requestOptions).then(handleResponse)
}

function getBookerRecruiters() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/users/get-booker-recruiters`, requestOptions).then(
    handleResponse,
  )
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text)
    if (!response.ok) {
      if (response.status === 401) {
        logout()
      }

      const error = data || response.statusText
      return Promise.reject(error)
    }

    return data
  })
}
